import React from 'react'
import styles from './Footer.module.css'
import logo from '../../../assets/icons/logo.svg'
import { FaFacebook, FaInstagram } from 'react-icons/fa6'
import { connect } from 'react-redux'
import { RootState } from '../../../types/store.types'
import { getCategories } from '../../../redux/reducers/category-reducer'
import { CategoryType } from '../../../types/category.types'
import { useEffect } from 'react'
import { NavLink } from 'react-router-dom'

interface FooterProps {
    getCategories: () => void,
    categories: CategoryType[]
    isFetching: boolean
}
const Footer = (props: FooterProps) => {
    useEffect(() => {
        props.getCategories()
    }, [])
    return (
        <footer className={styles.footer}>
            <div className={styles.footerContainer}>
                <div className={styles.website}>
                    <img src={logo} alt="logo" className={styles.logo} />
                    <p className={styles.number}>+380 680 258 862</p>
                    <div className={styles.icons}>
                        <a href='https://www.instagram.com/tactical_forma/' target='_blank'><FaInstagram className={styles.icon} /></a>
                    </div>
                    <p className={styles.copyright}>2025®</p>
                </div>
                <div className={styles.links}>
                    <div className={styles.categoryLinks}>
                        <h3 className={styles.title}>Категорії: </h3>
                        <div className={styles.linksContainer}>
                            {!props.isFetching ? (
                                props.categories.map((category: CategoryType) => {
                                    return (
                                        <NavLink to={`/category/${category.category_id}`} key={category.category_id} className={styles.link}>
                                            {category.name}
                                        </NavLink>
                                    );
                                })
                            ) : (
                                <p>Завантаження...</p>
                            )}
                        </div>
                    </div>
                    <div className={styles.infoLinks}>
                        <h3 className={styles.title}>Інформація</h3>
                        <div className={styles.linksContainer}>
                            <a href="/#about" className={styles.link} rel="noopener noreferrer">Про нас</a>
                            <a href="/#delivery" className={styles.link} rel="noopener noreferrer">Доставка</a>
                            <a href="/#payment" className={styles.link} rel="noopener noreferrer">Оплата</a>
                            <a href="/#returns" className={styles.link} rel="noopener noreferrer">Повернення</a>
                            <a href="/offerta/offerta.pdf" className={styles.link} target="_blank" rel="noopener noreferrer">Політика</a>

                        </div>
                    </div>
                    <div className={styles.contactLinks}>
                        <h3 className={styles.title}>Контакти</h3>
                        <div className={styles.linksContainer}>
                            <a href="tel:+380680258862" className={styles.link}>+380 680 258 862</a>
                            <a href="mailto:tactical.forma@gmail.com" className={styles.link}>tactical.forma@gmail.com</a>
                        </div>

                    </div>
                    <div className={styles.adressContainer}>
                        <h3 className={styles.title}>Адреса</h3>
                        <p className={styles.link} style={{ width: '80px' }}>24400, С.ВЕЛИКА КИРИЇВКА, ВУЛ.ГАГАРІНА БУД.72</p>
                    </div>
                </div>

            </div>
        </footer>
    )
}

let mapStateToProps = (state: RootState) => {
    return {
        categories: state.category.categories,
        isFetching: state.category.isFetching
    }
}
let mapDispatchToProps = {
    getCategories
}
export default connect(mapStateToProps, mapDispatchToProps)(Footer)
